import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=08b5b18d&scoped=true"
import script from "./ProjectDescription.vue?vue&type=script&lang=js"
export * from "./ProjectDescription.vue?vue&type=script&lang=js"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=08b5b18d&prod&lang=css"
import style1 from "./ProjectDescription.vue?vue&type=style&index=1&id=08b5b18d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5b18d",
  null
  
)

export default component.exports